import { render, staticRenderFns } from "./OpenStatesDefaults.vue?vue&type=template&id=7968c8ae&lang=pug"
import script from "./OpenStatesDefaults.vue?vue&type=script&lang=js"
export * from "./OpenStatesDefaults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports